import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import LobbyConnection from "@/Poker/io/LobbyConnection";
import createLobbyConnection from "@/Poker/io/helpers/LobbyHelper";
import store from "@/Poker/redux/store";
import { useA23Token } from "../hooks/data/useLobby";

export default function LobbyServiceProvider({ children }) {
  const dispatch = useDispatch();
  const [lobbyConnection, setLobbyConnection] = useState(null);
  const a23Token = useA23Token();

  useEffect(() => {
    const initializeLobbyConnection = () => {
      let baseClient = createLobbyConnection(
        store,
        dispatch
      );
      let lobbyConnection = LobbyConnection.getInstance();
      lobbyConnection.addLobbyConnection(baseClient[2]);
      setLobbyConnection(lobbyConnection);
    }

    if (a23Token && !lobbyConnection) {
      initializeLobbyConnection();
    }

  }, [a23Token, lobbyConnection, dispatch]);

  return children
}
